var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import _ from 'lodash';

import { getDefaultRegistry, getUiOptions, isMultiSelect, isFilesArray, isSelect, isFixedItems, allowAdditionalItems, optionsList, getDefaultFormState } from "../utils/";

var SchemaLayout = (_temp2 = _class = function (_Component) {
    _inherits(SchemaLayout, _Component);

    function SchemaLayout() {
        var _temp, _this, _ret;

        _classCallCheck(this, SchemaLayout);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.isEditing = function () {
            var _this$props = _this.props,
                id = _this$props.id,
                uiOptions = _this$props.uiOptions,
                registry = _this$props.registry;
            var editable = uiOptions.editable;
            var formContext = registry.formContext;
            var editId = formContext.editId;


            var editing = void 0;

            if (editable && editId && editId.startsWith(id)) {
                return true;
            }

            return false;
        }, _this.isExpanded = function () {
            var _this$props2 = _this.props,
                id = _this$props2.id,
                uiOptions = _this$props2.uiOptions,
                registry = _this$props2.registry;
            var collapsible = uiOptions.collapsible;
            var formContext = registry.formContext;
            var expandId = formContext.expandId;


            var expanded = void 0;

            if (collapsible && expandId && expandId.startsWith(id)) {
                return true;
            } else if (collapsible) {
                return false;
            }

            return true;
        }, _this.isSettingsExpanded = function (id) {
            var formContext = _this.props.registry.formContext;


            var expanded = void 0;

            if (formContext.settings && formContext.settings === id) {
                expanded = true;
            } else {
                expanded = false;
            }

            return expanded;
        }, _this.onEdit = function (id) {
            if (!id) {
                id = _this.props.id;
            }

            var uiOptions = _this.props.uiOptions;


            console.log('layout:onEdit', id);

            var menu = _this.getMenu(uiOptions);

            var _this$props3 = _this.props,
                schema = _this$props3.schema,
                formData = _this$props3.formData;
            var formContext = _this.props.registry.formContext;


            if (formContext.onEdit) {
                formContext.onEdit({
                    id: id,
                    schema: schema,
                    formData: formData
                });
            }
        }, _this.onSave = function (id) {
            if (!id) {
                id = _this.props.id;
            }

            console.log('layout:onSave', id);

            var _this$props4 = _this.props,
                schema = _this$props4.schema,
                formData = _this$props4.formData;
            var formContext = _this.props.registry.formContext;


            if (formContext.onSave) {
                formContext.onSave({
                    id: id,
                    schema: schema,
                    formData: formData
                });
            }
        }, _this.onDelete = function (id) {
            if (!id) {
                id = _this.props.id;
            }

            console.log('layout:onDelete', id);

            if (_this.props.onRemoveItem) {
                _this.props.onRemoveItem();
            } else {
                _this.onRemoveReference();
            }

            setTimeout(function () {
                //            this.onCollapse(id)
                _this.onSettings(undefined);
            });
        }, _this.onSubmit = function (event) {
            console.log('layout:onSubmit', event);

            var formContext = _this.props.registry.formContext;


            if (formContext.onSubmit) {
                formContext.onSubmit(event);
            }
        }, _this.onExpand = function (id) {
            if (!id) {
                id = _this.props.id;
            }

            console.log('layout:onExpand', id);

            var formContext = _this.props.registry.formContext;


            if (formContext.onExpand) {
                formContext.onExpand(id);
            }

            _this.onDialogChange();
        }, _this.onCollapse = function (id) {
            if (!id) {
                id = _this.props.id;
            }

            console.log('layout:onCollapse', id);

            var formContext = _this.props.registry.formContext;


            if (formContext.onCollapse) {
                formContext.onCollapse(id);
            }

            _this.onDialogChange();
        }, _this.onToggle = function (id) {
            if (!id || typeof id !== "string") {
                id = _this.props.id;
            }

            console.log('layout:onToggle', id);

            var formContext = _this.props.registry.formContext;


            if (formContext.onToggle) {
                formContext.onToggle(id);
            }

            _this.onDialogChange();
        }, _this.onChange = function (formData) {
            console.log('layout:onChange', formData);

            if (_this.props.onChange) {
                _this.props.onChange(formData);
            }

            setTimeout(function () {
                _this.onDialogChange();
            });
        }, _this.onUpload = function (acceptedFiles, rejectedFiles) {
            console.log('layout:onUpload');

            var _this$props5 = _this.props,
                id = _this$props5.id,
                schema = _this$props5.schema,
                formData = _this$props5.formData;
            var formContext = _this.props.registry.formContext;


            if (formContext.onUpload) {
                formContext.onUpload({
                    id: id,
                    acceptedFiles: acceptedFiles,
                    rejectedFiles: rejectedFiles,
                    schema: schema,
                    formData: formData,
                    onAdd: _this.onUploadAdd,
                    onUpdate: _this.onUploadChange
                });
            }
        }, _this.onUploadAdd = function (item) {
            console.log('layout:onUploadAdd', item);

            var schema = _this.props.schema;


            if (schema.type === "array") {
                _this.onArrayAdd(item);
            }

            if (schema.type === "object") {
                _this.onChange(item);
            }
        }, _this.onUploadChange = function (item) {
            console.log('layout:onUploadChange', item);

            var schema = _this.props.schema;


            if (schema.type === "array") {
                _this.onUpdateArrayReference(item);
            }

            if (schema.type === "object") {
                _this.onChange(item);
            }
        }, _this.onDialog = function (type) {
            //        event.preventDefault();

            var _this$props6 = _this.props,
                id = _this$props6.id,
                schema = _this$props6.schema,
                formData = _this$props6.formData;
            var formContext = _this.props.registry.formContext;


            console.log('layout:onDialog', id);

            if (formContext.onDialog) {
                formContext.onDialog({
                    id: id,
                    expanded: true,
                    type: type,
                    schema: schema,
                    formData: formData,
                    onAdd: _this.onDialogAdd,
                    onRemove: _this.onDialogRemove
                });
            }
        }, _this.onDialogAdd = function (item) {
            console.log('layout:onDialogAdd', item);

            var schema = _this.props.schema;


            if (schema.type === "array") {
                _this.onArrayAdd(item);
            }

            if (schema.type === "object") {
                _this.onChange(item);
            }
        }, _this.onDialogRemove = function (item) {
            console.log('layout:onDialogRemove', item);

            var schema = _this.props.schema;


            if (schema.type === "array") {
                _this.onRemoveArrayReference(item);
            }

            if (schema.type === "object") {
                _this.onRemoveReference();
            }
        }, _this.onDialogChange = function () {
            var _this$props7 = _this.props,
                id = _this$props7.id,
                schema = _this$props7.schema,
                formData = _this$props7.formData;
            var formContext = _this.props.registry.formContext;


            console.log('layout:onDialogChange', id);

            if (formContext.onDialog && formContext.dialog) {

                if (formContext.dialog.id && formContext.dialog.id === id) {

                    formContext.onDialogChange(formData);

                    /*
                     formContext.onDialog({
                        ...formContext.dialog,
                        formData: formData
                    })
                    
                    */
                } else {

                    formContext.onDialog({
                        expanded: false
                    });
                }
            }
        }, _this.onRemove = function () {
            var _this$props8 = _this.props,
                id = _this$props8.id,
                schema = _this$props8.schema,
                formData = _this$props8.formData;
            var formContext = _this.props.registry.formContext;


            if (formContext.onRemove) {
                formContext.onRemove({
                    id: id,
                    schema: schema,
                    formData: formData
                });
            }

            console.log('layout:onRemove', id);

            if (_this.props.onRemove) {
                _this.props.onRemove();
            } else {
                _this.onRemoveReference();
            }

            setTimeout(function () {
                _this.onSettings(undefined);
            });
        }, _this.onRemoveReference = function () {
            var _this$props9 = _this.props,
                schema = _this$props9.schema,
                formData = _this$props9.formData,
                registry = _this$props9.registry;
            var definitions = registry.definitions;


            var newFormData = getDefaultFormState(schema, undefined, definitions);

            _this.onChange(newFormData);
        }, _this.removeArrayReference = function (formData, reference) {
            var uniqueId = reference.uniqueId,
                schemaId = reference.schemaId,
                referenceId = reference.referenceId,
                mediaId = reference.mediaId;


            var newFormData = void 0;

            if (uniqueId) {

                newFormData = formData.filter(function (item) {
                    return item.uniqueId !== reference.uniqueId;
                });
            }

            if (schemaId) {

                newFormData = formData.filter(function (item) {
                    return item.schemaId !== reference.schemaId;
                });
            }

            if (referenceId) {

                newFormData = formData.filter(function (item) {
                    return item.referenceId !== reference.referenceId;
                });
            }

            if (mediaId) {

                newFormData = formData.filter(function (item) {
                    return item.mediaId !== reference.mediaId;
                });
            }

            return newFormData;
        }, _this.updateArrayReference = function (formData, reference) {
            var uniqueId = reference.uniqueId,
                schemaId = reference.schemaId,
                referenceId = reference.referenceId,
                mediaId = reference.mediaId;


            var newFormData = void 0;

            if (uniqueId) {

                newFormData = formData.map(function (item) {
                    if (item.uniqueId === reference.uniqueId) {
                        return reference;
                    }
                    return item;
                });
            }

            if (schemaId) {

                newFormData = formData.map(function (item) {
                    if (item.schemaId === reference.schemaId) {
                        return reference;
                    }
                    return item;
                });
            }

            if (referenceId) {

                newFormData = formData.map(function (item) {
                    if (item.referenceId === reference.referenceId) {
                        return reference;
                    }
                    return item;
                });
            }

            if (mediaId) {

                newFormData = formData.map(function (item) {
                    if (item.mediaId === reference.mediaId) {
                        return reference;
                    }
                    return item;
                });
            }

            return newFormData;
        }, _this.onUpdateArrayReference = function (reference) {
            var formData = _this.props.formData;


            var newFormData = _this.updateArrayReference(formData, reference);

            _this.onChange(newFormData);
        }, _this.onRemoveArrayReference = function (reference) {
            var formData = _this.props.formData;


            var newFormData = _this.removeArrayReference(formData, reference);

            _this.onChange(newFormData);
        }, _this.onAdd = function (formData) {
            var _this$props10 = _this.props,
                id = _this$props10.id,
                schema = _this$props10.schema;
            var formContext = _this.props.registry.formContext;


            console.log('layout:onAdd', formData);

            if (formContext.onAdd) {
                formContext.onAdd({
                    id: id,
                    schema: schema,
                    formData: formData
                });
            }

            if (schema.type === "array") {
                _this.onArrayAdd(formData);
            } else {
                _this.onAddReference(formData);
            }
        }, _this.onAddBefore = function (formData) {
            if (_this.props.onAddBefore) {
                _this.props.onAddBefore(formData);
            }
        }, _this.onAddAfter = function (formData) {
            if (_this.props.onAddAfter) {
                _this.props.onAddAfter(formData);
            }
        }, _this.onAddReference = function (formData) {
            var _this$props11 = _this.props,
                schema = _this$props11.schema,
                registry = _this$props11.registry;
            var definitions = registry.definitions;


            var newFormData = getDefaultFormState(schema, formData, definitions);

            _this.onChange(newFormData);
        }, _this.onArrayAdd = function (item) {
            console.log('layout:onArrayAdd', item);

            var _this$props12 = _this.props,
                schema = _this$props12.schema,
                formData = _this$props12.formData,
                registry = _this$props12.registry,
                canAdd = _this$props12.canAdd;
            var definitions = registry.definitions;


            if (!canAdd) {
                return false;
            }

            var itemSchema = schema.items;

            if (isFixedItems(schema) && allowAdditionalItems(schema)) {
                itemSchema = schema.additionalItems;
            }

            var newFormData = [].concat(formData, getDefaultFormState(itemSchema, item, definitions));

            if (newFormData) {
                _this.onChange(newFormData);
            }
        }, _this.onMoveUp = function (event) {
            if (_this.props.onMoveUp) {
                _this.props.onMoveUp(event);
            }
        }, _this.onMoveDown = function (event) {
            if (_this.props.onMoveDown) {
                _this.props.onMoveDown(event);
            }
        }, _this.onSettings = function (id) {
            console.log('layout:onSettings', id);
            var formContext = _this.props.registry.formContext;


            if (formContext.settings === id) {
                formContext.onSettings(false);
            } else if (formContext.onSettings) {
                formContext.onSettings(id);
            }
        }, _this.onSettingsAction = function (name, value) {
            var _extends2;

            var _this$props13 = _this.props,
                schema = _this$props13.schema,
                formData = _this$props13.formData;


            if (!schema.type === "object") {
                return false;
            }

            _this.onChange(_extends({}, formData, (_extends2 = {}, _extends2[name] = value, _extends2)));

            setTimeout(function () {
                _this.onSettings(false);
            });
        }, _this.onSettingsSelect = function (name, value) {
            console.log('layout:onSettingsSelect', name + ":" + value);

            _this.onSettingsChange(name, value);

            setTimeout(function () {
                _this.onSettings(false);
            });
        }, _this.onSettingsChange = function (name, value) {
            console.log('layout:onSettingsChange', name + ":" + value);

            var _this$props14 = _this.props,
                schema = _this$props14.schema,
                formData = _this$props14.formData,
                uiOptions = _this$props14.uiOptions;


            if (!schema.type === "object") {
                return false;
            }

            if (Array.isArray(uiOptions.settings)) {
                var _extends3;

                _this.onChange(_extends({}, formData, (_extends3 = {}, _extends3[name] = value, _extends3)));
            } else {
                var _extends4;

                var settings = formData.settings || {};
                var newSettings = {};

                newSettings = _extends({}, settings, (_extends4 = {}, _extends4[name] = value, _extends4));

                _this.onChange(_extends({}, formData, {
                    settings: newSettings
                }));
            }
        }, _this.getSettingsVisibility = function (uiLayout) {
            var hideable = uiLayout.hideable,
                deletable = uiLayout.deletable,
                restorable = uiLayout.restorable;
            var _this$props15 = _this.props,
                id = _this$props15.id,
                formData = _this$props15.formData,
                hasRemove = _this$props15.hasRemove,
                index = _this$props15.index;


            var settingsId = _this.props.id + '_settings_visibility';
            var expanded = _this.isSettingsExpanded(settingsId);

            var options = [];

            // hidden

            var hidden = false;

            if (formData && formData.hidden) {
                hidden = formData.hidden;
            }

            // action

            var _action = void 0;

            if (formData && formData._action) {
                _action = formData._action;
            }

            // hideable

            if (hideable) {

                options.push({
                    icon: "visibility",
                    title: "Visible",
                    name: "hidden",
                    value: false,
                    onClick: function onClick() {
                        return _this.onSettingsAction('hidden', false);
                    }
                });

                options.push({
                    icon: "visibility_off",
                    title: "Hidden",
                    name: "hidden",
                    value: true,
                    onClick: function onClick() {
                        return _this.onSettingsAction('hidden', true);
                    }
                });
            }

            // deletable && restorable

            if (deletable && restorable) {

                if (_action === "delete") {
                    options.push({
                        title: "Restore",
                        type: "secondary",
                        onClick: function onClick() {
                            return _this.onSettingsAction('_action', "restore");
                        }
                    });
                } else {
                    options.push({
                        title: "Delete",
                        type: "secondary",
                        onClick: function onClick() {
                            return _this.onSettingsAction('_action', "delete");
                        }
                    });
                }

                // deletable
            } else if (deletable || hasRemove) {

                options.push({
                    title: "Delete",
                    type: "secondary",
                    onClick: function onClick() {
                        return _this.onDelete(id);
                    }
                });
            }

            // set icon

            var icon = void 0;

            if (_action && _action === "delete") {
                icon = "restore";
            } else if (hidden) {
                icon = "visibility_off";
            } else {
                icon = "visibility";
            }

            return {
                id: settingsId,
                expanded: expanded,
                onClick: function onClick() {
                    return _this.onSettings(settingsId);
                },
                icon: icon,
                name: "hidden",
                value: hidden,
                type: "visibility",
                options: options
            };
        }, _this.getSettingsOption = function (name, option, index) {
            var value = option.value;


            return _extends({}, option, {
                onClick: function onClick() {
                    return _this.onSettingsChange(name, value);
                }
            });
        }, _this.getSchemaSettingsField = function (schema, name, value) {

            var id = _this.props.id + '_settings_' + name;
            var expanded = _this.isSettingsExpanded(id);

            var enumOptions = isSelect(schema) && optionsList(schema);

            var options = void 0;

            if (enumOptions) {
                options = enumOptions.map(function (option) {
                    return _this.getSettingsOption(name, option);
                });
            } else {
                options = [];
            }

            if (enumOptions && !value) {
                value = schema.enum[0];
            }

            return {
                id: id,
                expanded: expanded,
                type: schema.format || name,
                name: name,
                value: value,
                onClick: function onClick() {
                    return _this.onSettings(id);
                },
                onChange: _this.onSettingsChange,
                options: options
            };
        }, _this.getSchemaSettings = function () {
            var _this$props16 = _this.props,
                schema = _this$props16.schema,
                formData = _this$props16.formData,
                uiOptions = _this$props16.uiOptions;


            if (!uiOptions.settings) {
                return [];
            }

            var settings = [];

            if (Array.isArray(uiOptions.settings)) {

                uiOptions.settings.map(function (name) {
                    var value = formData[name] || undefined;

                    if (schema.properties[name]) {
                        var field = _this.getSchemaSettingsField(schema.properties[name], name, value);
                        settings.push(field);
                    }
                });
            } else if (uiOptions.settings && schema.properties.settings && schema.properties.settings.type === "object") {

                settings = Object.keys(schema.properties.settings.properties).map(function (name) {
                    var value = formData.settings[name] || undefined;
                    var field = _this.getSchemaSettingsField(schema.properties.settings.properties[name], name, value);
                    return field;
                });
            }

            return settings;
        }, _this.getArrayItemSettings = function (settings) {
            var _this$props17 = _this.props,
                hasToolbar = _this$props17.hasToolbar,
                hasMoveUp = _this$props17.hasMoveUp,
                hasMoveDown = _this$props17.hasMoveDown,
                hasRemove = _this$props17.hasRemove;


            if (hasMoveUp) {
                settings.push({
                    icon: "arrow_upward",
                    onClick: _this.onMoveUp
                });
            } else if (hasToolbar) {
                settings.push({
                    icon: "arrow_upward",
                    disabled: true
                });
            }

            if (hasMoveDown) {
                settings.push({
                    icon: "arrow_downward",
                    onClick: _this.onMoveDown
                });
            } else {
                settings.push({
                    icon: "arrow_downward",
                    disabled: true
                });
            }

            return settings;
        }, _this.getSettings = function (uiLayout) {
            var collapsible = uiLayout.collapsible,
                editable = uiLayout.editable,
                editing = uiLayout.editing,
                addable = uiLayout.addable,
                removable = uiLayout.removable,
                hideable = uiLayout.hideable,
                deletable = uiLayout.deletable,
                restorable = uiLayout.restorable;
            var _this$props18 = _this.props,
                id = _this$props18.id,
                schema = _this$props18.schema,
                uiOptions = _this$props18.uiOptions,
                formData = _this$props18.formData,
                formContext = _this$props18.formContext,
                hasToolbar = _this$props18.hasToolbar,
                hasMoveUp = _this$props18.hasMoveUp,
                hasMoveDown = _this$props18.hasMoveDown,
                hasRemove = _this$props18.hasRemove;


            var settings = [];

            // schema settings, ui:settings=true, and we have a settings object

            if (uiLayout.settings && schema.type === "object") {
                settings = _this.getSchemaSettings();
            }

            // array item settings

            if (hasToolbar) {
                settings = _this.getArrayItemSettings(settings);
            }

            // editable

            if (editable && !editing) {
                settings.unshift({
                    icon: "edit",
                    onClick: function onClick() {
                        return _this.onEdit(id);
                    }
                });
            }

            // visibility settings

            var visibility = void 0;

            // restore

            if (deletable && restorable && formData && formData._action && formData._action === "delete") {

                settings = [];

                settings.push({
                    icon: "restore",
                    name: "restore",
                    onClick: function onClick() {
                        return _this.onSettingsAction('_action', "restore");
                    }
                });

                return settings;

                // hideable => visibility options
            } else if (hideable) {
                visibility = _this.getSettingsVisibility(uiLayout);
                settings.push(visibility);

                // remove
            } else if (deletable || hasRemove) {
                settings.push({
                    icon: "remove_circle",
                    onClick: function onClick() {
                        return _this.onDelete(id);
                    }
                });

                // addable    
            } else if (addable) {
                settings.push({
                    icon: "add_circle",
                    onClick: function onClick() {
                        return _this.onAdd();
                    }
                });

                // removable
            } else if (removable) {
                settings.push({
                    icon: "remove_circle",
                    onClick: function onClick() {
                        return _this.onRemove();
                    }
                });
            }

            return settings;
        }, _this.getDisabledButton = function (button, index) {

            if (typeof button === "string") {
                button = {
                    label: button,
                    type: button
                };
            }

            var _button = button,
                item = _button.item,
                type = _button.type;


            return _extends({}, button, {
                disabled: true
            });
        }, _this.getSidebarButton = function (button, schema) {

            if (!schema || !schema.properties) {
                return button;
            }

            var _schema$properties = schema.properties,
                mediaId = _schema$properties.mediaId,
                referenceId = _schema$properties.referenceId,
                schemaId = _schema$properties.schemaId,
                objectId = _schema$properties.objectId;


            var mediaType = void 0;

            var label = void 0,
                type = void 0;

            if (mediaId) {

                var _mediaType = void 0;

                if (schema.properties.media && schema.properties.media.properties && schema.properties.media.properties.mediaType && schema.properties.media.properties.mediaType.default) {
                    _mediaType = schema.properties.media.properties.mediaType.default;
                }

                if (_mediaType === "image") {
                    type = "sidebar/media/image";
                    label = "Image";
                } else if (_mediaType === "video") {
                    type = "sidebar/media/video";
                    label = "Video";
                } else if (_mediaType === "audio") {
                    type = "sidebar/media/audio";
                    label = "Audio";
                } else {
                    type = "sidebar/media";
                    label = "Media";
                }
            } else if (referenceId) {
                type = "sidebar/reference";
                label = "Reference";

                var documentType = void 0;

                if (schema.properties.reference && schema.properties.reference.properties && schema.properties.reference.properties.documentType && schema.properties.reference.properties.documentType.default) {
                    documentType = schema.properties.reference.properties.documentType.default;
                }

                if (documentType) {
                    type = "sidebar/reference/" + documentType;
                    label = "Find " + documentType;
                }
            }

            return _extends({}, button, {
                type: type,
                icon: "search",
                label: label,
                onClick: function onClick() {
                    return _this.onDialog(type);
                }
            });
        }, _this.getUploadButton = function (button, schema) {

            if (!schema || !schema.properties) {

                return {
                    label: "failed"
                };

                return button;
            }

            var mediaType = void 0,
                accept = void 0;

            if (schema.properties.media && schema.properties.media.properties && schema.properties.media.properties.mediaType && schema.properties.media.properties.mediaType.default) {
                mediaType = schema.properties.media.properties.mediaType.default;
            }

            if (mediaType) {

                if (mediaType === "image") {
                    accept = "image/*";
                }

                if (mediaType === "video") {
                    accept = "video/*";
                }

                if (mediaType === "audio") {
                    accept = "audio/*";
                }
            }

            return _extends({}, button, {
                type: "upload",
                accept: accept,
                onUpload: _this.onUpload
            });
        }, _this.getUiButton = function (button, index) {

            // accept strings

            if (typeof button === "string" && button === "submit") {

                button = {
                    label: "Submit",
                    type: button
                };
            }

            if (typeof button === "string" && button === "upload") {

                button = {
                    label: "Upload",
                    type: button

                };
            }

            if (typeof button === "string" && button === "sidebar") {

                button = {
                    label: "Sidebar",
                    type: button

                };
            }

            var _button2 = button,
                item = _button2.item,
                type = _button2.type;
            var schema = _this.props.schema;


            var buttonSchema = void 0;

            if (schema.type === "array") {
                buttonSchema = schema.items;
            } else {
                buttonSchema = schema;
            }

            if (type && type === "upload") {

                var multiple = void 0;

                if (schema.type === "array") {
                    multiple = true;
                } else {
                    multiple = false;
                }

                return _this.getUploadButton(_extends({}, button, { multiple: multiple }), buttonSchema);
            }

            if (type && type === "sidebar") {
                return _this.getSidebarButton(button, buttonSchema);
            }

            if (type && type === "submit") {

                return _extends({}, button, {
                    onClick: function onClick(event) {
                        return _this.onSubmit(event);
                    }
                });
            }

            if (type) {

                return _extends({}, button, {
                    onClick: function onClick() {
                        return _this.onDialog(type);
                    }
                });
            }

            if (item) {

                return _extends({}, button, {
                    onClick: function onClick() {
                        return _this.onAdd(item);
                    }
                });
            }

            return _extends({}, button, {
                onClick: function onClick() {
                    return _this.onAdd();
                }
            });

            return button;
        }, _this.getObjectButtons = function () {
            var _this$props19 = _this.props,
                canAdd = _this$props19.canAdd,
                uiOptions = _this$props19.uiOptions;
            var buttons = uiOptions.buttons;


            if (Array.isArray(buttons) && buttons.length) {
                return buttons.map(_this.getUiButton);
            }
        }, _this.getArrayButtons = function () {
            var _this$props20 = _this.props,
                canAdd = _this$props20.canAdd,
                uiOptions = _this$props20.uiOptions;
            //        const { buttons, addable } = uiLayout;

            var buttons = uiOptions.buttons,
                addable = uiOptions.addable;


            if (addable === false) {
                return false;
            }

            if (canAdd && Array.isArray(buttons) && buttons.length) {

                return buttons.map(_this.getUiButton);
            } else if (Array.isArray(buttons) && buttons.length) {

                return buttons.map(_this.getDisabledButton);
            } else if (canAdd) {

                return [{
                    label: "Add",
                    //                    onClick: (event) => this.onAdd(event)
                    onClick: function onClick() {
                        return _this.onAdd();
                    }
                    //                    onClick: this.onAdd
                }];
            } else {

                return [{
                    label: "Add",
                    disabled: true
                }];
            }
        }, _this.getButtons = function (uiLayout) {
            var schema = _this.props.schema;


            var buttons = void 0;

            if (schema.type === "array") {
                buttons = _this.getArrayButtons();
            }

            if (schema.type === "object") {
                buttons = _this.getObjectButtons();
            }

            return buttons;
        }, _this.getMenu = function (uiLayout) {
            var _this$props21 = _this.props,
                formContext = _this$props21.formContext,
                schema = _this$props21.schema,
                fields = _this$props21.fields;
            var nav = uiLayout.nav;


            if (!nav) {
                return false;
            }

            var menu = [];

            // menu from fields

            if (fields) {

                fields.forEach(function (field) {
                    var id = field.id,
                        name = field.name,
                        uiSchema = field.uiSchema;


                    var uiOptions = getUiOptions(uiSchema);

                    var selected = false;

                    if (formContext.expandId && formContext.expandId.startsWith(id)) {
                        selected = true;
                    }

                    var title = uiOptions['title'] || name;
                    var icon = uiOptions['icon'] || false;

                    menu.push(_extends({}, field, {
                        selected: selected,
                        title: title,
                        icon: icon,
                        onClick: function onClick() {
                            return _this.onExpand(id);
                        }
                    }));
                });
            }

            if (!menu.length) {
                return false;
            }

            var selected = _.find(menu, function (field) {
                return field.selected === true;
            });

            if (menu[0] && !selected) {
                menu[0].selected = true;
            }

            return menu;
        }, _this.getPreview = function (preview) {
            var _this$props22 = _this.props,
                formData = _this$props22.formData,
                formContext = _this$props22.formContext,
                schema = _this$props22.schema;
            var language = formContext.language;

            // preview.single or preview.multiple

            if (schema.type === "array" && preview && preview.single && formData.length === 1) {
                preview = preview.single;
            }

            if (schema.type === "array" && preview && preview.multiple) {
                preview = preview.multiple;
            }

            // set value

            var value = void 0;

            if (preview && preview.select && formData && formData[preview.select] && formData[preview.select]['locale:' + language]) {
                value = formData[preview.select]['locale:' + language];
            } else if (preview && preview.select && formData && formData[preview.select]) {
                value = formData[preview.select];
            } else if (typeof preview === "string") {
                value = preview;
            }

            // count

            if (schema.type === "array" && value && typeof value === "string") {
                value = value.replace("[count]", formData.length);
            }

            if (value && (typeof value === "string" || typeof value === "number")) {
                return value;
            }

            return false;
        }, _this.getStyle = function (uiOptions) {

            var style = {};

            if (uiOptions.style) {

                Object.keys(uiOptions.style).map(function (name) {
                    var value = _this.getPreview(uiOptions.style[name]) || uiOptions.style[name] || undefined;
                    if (value) {
                        style[name] = value;
                    }
                });
            }

            return style;
        }, _this.getLayout = function () {
            var _this$props23 = _this.props,
                id = _this$props23.id,
                idPrefix = _this$props23.idPrefix,
                name = _this$props23.name,
                idSchema = _this$props23.idSchema,
                formData = _this$props23.formData,
                formContext = _this$props23.formContext,
                uiSchema = _this$props23.uiSchema,
                uiOptions = _this$props23.uiOptions,
                registry = _this$props23.registry;
            var editId = formContext.editId,
                expandId = formContext.expandId;
            var definitions = registry.definitions;


            var schema = _this.props.schema || {};
            var type = schema.type;

            // layout

            var layout = uiOptions.layout,
                widget = uiOptions.widget;

            // style + color

            var style = _this.getStyle(uiOptions);
            var color = _this.getPreview(uiOptions.color) || uiOptions.color || undefined;

            // media, imageUrl

            var imageUrl = _this.getPreview(uiOptions.imageUrl) || undefined;

            // title, description, summary, help

            var title = void 0,
                description = void 0,
                summary = void 0,
                help = void 0;

            title = _this.getPreview(uiOptions.title) || schema.title || name || formData.title || undefined;
            description = _this.getPreview(uiOptions.description) || schema.description || undefined;
            summary = _this.getPreview(uiOptions.summary) || undefined;
            help = uiOptions.help || undefined;

            if (uiOptions.label === false) {
                title = undefined;
            }

            // disabled, readonly, autofocus

            var disabled = Boolean(_this.props.disabled || uiSchema["ui:disabled"]);
            var readonly = Boolean(_this.props.readonly || uiSchema["ui:readonly"]);
            var autofocus = Boolean(_this.props.autofocus || uiSchema["ui:autofocus"]);

            // editable, editing

            var editable = Boolean(uiOptions.editable);
            var editing = _this.isEditing();

            // collapsible + expanded

            var collapsible = Boolean(uiOptions.collapsible);

            var expanded = void 0;

            if (uiOptions.expanded === false) {
                expanded = Boolean(uiOptions.expanded);
            } else if (uiOptions.expanded) {
                expanded = Boolean(uiOptions.expanded);
            } else {
                expanded = _this.isExpanded();
            }

            // hideable, deletable, restorable

            var hideable = Boolean(uiOptions.hideable);
            var deletable = Boolean(uiOptions.deletable);
            var restorable = Boolean(uiOptions.restorable);

            // orderable

            var orderable = void 0;

            if (uiOptions.orderable === false) {
                orderable = false;
            }

            // addable + removable

            var addable = void 0,
                removable = void 0;

            if (uiOptions.addable === false) {
                addable = false;
            } else {
                addable = Boolean(uiOptions.addable);
            }

            if (uiOptions.removable === false) {
                removable = false;
            } else {
                removable = Boolean(uiOptions.removable);
            }

            // simple layouts

            if (!layout && (type === "array" || type === "string" || type === "number" || type === "integer" || type === "boolean")) {
                layout = "field";
            }

            // default object with title => fieldset

            if (!layout) {
                layout = "fieldset";

                // remove title if not explicitly set

                if (!uiOptions.title && !schema.title) {
                    title = undefined;
                }
            }

            // show label?

            var label = void 0;

            if (uiOptions.label === false) {
                label = false;
            } else if (type === "boolean" && (widget === "select" || widget === "radio")) {
                label = true;
            } else if (type === "boolean") {
                label = false;
            } else {
                label = true;
            }

            return _extends({}, uiOptions, {

                id: id,
                idPrefix: idPrefix,
                type: type,

                collapsible: collapsible,
                expanded: expanded,

                editable: editable,
                editing: editing,

                addable: addable,
                removable: removable,

                hideable: hideable,
                deletable: deletable,
                restorable: restorable,

                disabled: disabled,
                readonly: readonly,
                autofocus: autofocus,

                label: label,

                imageUrl: imageUrl,

                title: title || undefined,
                description: description,
                help: help,
                summary: summary,

                layout: layout,

                style: style,
                color: color

            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    // onDelete

    // onSubmit

    // toggle + expand

    // onChange

    // onUpload

    // onDialog

    // onRemove

    // add

    // up/down

    // onSettings

    // settings

    // buttons

    // menu functions

    SchemaLayout.prototype.render = function render() {
        var _props = this.props,
            id = _props.id,
            index = _props.index,
            schema = _props.schema,
            formData = _props.formData,
            formContext = _props.formContext,
            uiOptions = _props.uiOptions,
            registry = _props.registry;

        // layout

        var uiLayout = this.getLayout();

        // settings, buttons, etc

        var settings = this.getSettings(uiLayout);
        var buttons = this.getButtons(uiLayout);
        var menu = this.getMenu(uiLayout);

        // expandId + expandName

        var expandId = formContext.expandId,
            expandName = formContext.expandName,
            editId = formContext.editId,
            editName = formContext.editName;

        // set layout

        var layouts = registry.layouts; // || getDefaultRegistry()

        var layout = uiLayout.layout;


        var FieldLayout = void 0;

        if (layout && layouts[layout]) {
            FieldLayout = layouts[layout];
        } else {
            FieldLayout = layouts['field'];
        }

        // preview

        var uiPreview = uiOptions.preview || undefined;

        return React.createElement(
            FieldLayout,
            _extends({}, uiLayout, uiPreview, {

                index: index,
                settings: settings,
                buttons: buttons,
                expandId: expandId,
                expandName: expandName,
                editId: editId,
                editName: editName,
                menu: menu,

                schema: schema,
                formData: formData,
                formContext: formContext,

                onChange: this.onChange,
                onSubmit: this.onSubmit,

                onUpload: this.onUpload,

                onAdd: this.onAdd,
                onAddBefore: this.onAddBefore,
                onAddAfter: this.onAddAfter,

                onRemove: this.onRemove,

                onEdit: this.onEdit,
                onSave: this.onSave,
                onDelete: this.onDelete,

                onExpand: this.onExpand,
                onCollapse: this.onCollapse,
                onToggle: this.onToggle,

                onSettings: this.onSettings }),
            this.props.children
        );
    };

    return SchemaLayout;
}(Component), _class.defaultProps = {
    id: undefined,
    hidden: false,
    readonly: false,
    required: false,
    collapsible: false,
    expanded: true
}, _temp2);


export default SchemaLayout;